var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBalanceSheetIllustration = function SvgBalanceSheetIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324,
    height: 250,
    fill: "none",
    viewBox: "0 0 324 250"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#BalanceSheetIllustration_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#BalanceSheetIllustration_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 220,
    x: 21.957,
    y: 8.51,
    fill: "url(#BalanceSheetIllustration_svg__c)",
    rx: 1.737,
    shapeRendering: "crispEdges",
    transform: "rotate(3 21.957 8.51)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 219,
    x: 16.5,
    y: 15.5,
    fill: "url(#BalanceSheetIllustration_svg__d)",
    fillOpacity: 0.56,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 219,
    x: 16.5,
    y: 15.5,
    stroke: "url(#BalanceSheetIllustration_svg__e)",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 4,
    x: 40,
    y: 39,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 4,
    x: 40,
    y: 47,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 2,
    x: 44,
    y: 72,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 2,
    x: 180,
    y: 72,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 2,
    x: 240,
    y: 72,
    fill: "#516B89",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#516B89",
    strokeWidth: 0.5,
    d: "M284 83H40"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 4,
    x: 44,
    y: 87.5,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 264,
    y: 88.5,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#516B89",
    strokeWidth: 0.5,
    d: "M284 96H40"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 4,
    x: 44,
    y: 100,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 208,
    y: 101,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 256,
    y: 101,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#516B89",
    strokeWidth: 0.5,
    d: "M284 108H40"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 4,
    x: 44,
    y: 112,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    x: 188,
    y: 113,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#516B89",
    strokeWidth: 0.5,
    d: "M284 120H40"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 4,
    x: 44,
    y: 124.5,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 2,
    x: 180,
    y: 125.5,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#516B89",
    strokeWidth: 0.5,
    d: "M284 133H40"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 4,
    x: 44,
    y: 137,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    x: 196,
    y: 138,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    x: 248,
    y: 138,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#516B89",
    strokeWidth: 0.5,
    d: "M284 145H40"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 4,
    x: 44,
    y: 149.5,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.152,
    height: 2,
    x: 255.848,
    y: 150.5,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#516B89",
    strokeWidth: 0.5,
    d: "M284 158H40"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 4,
    x: 44,
    y: 162.5,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.152,
    height: 2,
    x: 195.848,
    y: 163.5,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#516B89",
    strokeWidth: 0.5,
    d: "M284 171H40"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 4,
    x: 44,
    y: 175,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 204,
    y: 176,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    x: 248,
    y: 176,
    fill: "#8598AF",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 244,
    height: 12,
    x: 40,
    y: 187,
    fill: "#516B89",
    rx: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "BalanceSheetIllustration_svg__c",
    x1: 27.962,
    x2: 150.169,
    y1: 12.861,
    y2: 298.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111827",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BalanceSheetIllustration_svg__d",
    x1: 19.681,
    x2: 150.959,
    y1: 16.212,
    y2: 306.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#385677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BalanceSheetIllustration_svg__e",
    x1: 275,
    x2: 209.219,
    y1: 235,
    y2: 71.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516B89",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "BalanceSheetIllustration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h324v250H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "BalanceSheetIllustration_svg__b",
    width: 448.99,
    height: 380.857,
    x: -62.495,
    y: -64.429,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 8.683,
    result: "effect1_dropShadow_7_4700"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.815,
    dy: 10.42
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.645
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0431373 0 0 0 0 0.145098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_4700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7_4700",
    result: "shape"
  })))));
};
export default SvgBalanceSheetIllustration;